// Maison M'Passy — comportements partagés (accordéon FAQ, reveal au scroll, nav mobile, galerie produit)
(function () {
  // FAQ accordion
  document.querySelectorAll('.faq-item button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-answer');
      var open = btn.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.faq-item button[aria-expanded="true"]').forEach(function (openBtn) {
        if (openBtn !== btn) {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.closest('.faq-item').querySelector('.faq-answer').style.maxHeight = null;
        }
      });

      btn.setAttribute('aria-expanded', String(!open));
      answer.style.maxHeight = open ? null : answer.scrollHeight + 'px';
    });
  });

  // Reveal on scroll
  var toReveal = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && toReveal.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    toReveal.forEach(function (el) { io.observe(el); });
  } else {
    toReveal.forEach(function (el) { el.classList.add('in'); });
  }

  // Mobile nav
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Product image carousel
  document.querySelectorAll('[data-mmp-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.mmp-gallery-track');
    var slides = gallery.querySelectorAll('.mmp-gallery-slide');
    var thumbs = gallery.querySelectorAll('.mmp-gallery-thumb');
    var prev = gallery.querySelector('.mmp-gallery-arrow.prev');
    var next = gallery.querySelector('.mmp-gallery-arrow.next');
    if (!track || !slides.length) return;

    function goTo(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function currentIndex() {
      var width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    }

    function setActiveThumb() {
      var idx = currentIndex();
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === idx); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(setActiveThumb, 100);
    });
  });

  // Pages with a full-bleed hero: header scrolls away with the page instead
  // of staying pinned (see .has-hero override in mmp-style.css).
  var header = document.querySelector('.site-header');
  if (document.querySelector('.hero')) document.body.classList.add('has-hero');

  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 8 ? '0 1px 0 rgba(0,0,0,.06)' : 'none';
    });
  }
})();
